import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'DFuaWy',
    defaultMessage: 'Edit Snapshot Cards',
    description: 'Title for modal to edit operations snapshot card selection',
  },
  modalSubtitle: {
    id: 'dokHg3',
    defaultMessage: 'Select up to 3 cards to display in your Operations Snapshot.',
    description: 'Instructions for card selection modal',
  },
  save: {
    id: 'CJ2hhQ',
    defaultMessage: 'Save',
    description: 'Button to save card selection',
  },
  cancel: {
    id: 'iUUEEx',
    defaultMessage: 'Cancel',
    description: 'Button to cancel changes',
  },
  selectionCount: {
    id: 'gygdqc',
    defaultMessage: '{count}/3 selected',
    description: 'Shows how many cards are currently selected',
  },
});
